import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeRegion: localStorage.getItem("OTC_V2_ACTIVE_REGION") || "",
};

const activeRegionSlice = createSlice({
  name: "activeRegion",
  initialState,
  reducers: {
    setActiveRegion(state, action) {
      state.activeRegion =
        typeof action.payload === "string" ? action.payload : "";
    },
    clearActiveRegion(state) {
      state.activeRegion = "";
    },
  },
});

export const { setActiveRegion, clearActiveRegion } = activeRegionSlice.actions;
export const selectActiveRegion = (state) =>
  (state.activeRegion && state.activeRegion.activeRegion) || "";
export default activeRegionSlice.reducer;
